// 原手机加购按钮下拉的时候固定到底部   暂时隐藏
// document.addEventListener('DOMContentLoaded', function() {
//             var button = document.querySelector('#two-column-section .product-form .product-form__submit');
//             if (button) {
//               var buttonRect = button.getBoundingClientRect(); 
//               var buttonOriginalTop = buttonRect.top + window.scrollY;
//               window.addEventListener('scroll', function() {
//                   var scrollTop = window.scrollY; 
//                   if (scrollTop > buttonOriginalTop) {
//                       button.classList.add('fixed-bottom_hu');
//                   } else {
//                       button.classList.remove('fixed-bottom_hu'); 
//                   }
//               });
//             }
//         });

  document.addEventListener('DOMContentLoaded', function () {
            const textElement = document.querySelector('.click_text');
            const imgElement = document.querySelector('.click_img');
            const overlay = document.querySelector('.overlay_hu');

            if (textElement && imgElement && overlay) {
                textElement.addEventListener('click', function () {
                    imgElement.style.display = 'block';
                    overlay.style.display = 'block';
                });

                imgElement.addEventListener('click', function () {
                    imgElement.style.display = 'none';
                    overlay.style.display = 'none';
                });

                overlay.addEventListener('click', function () {
                    imgElement.style.display = 'none';
                    overlay.style.display = 'none';
                });
            } else {
                console.error('not found');
            }
        });



/* 底部加购按钮 */

// document.addEventListener('DOMContentLoaded', function() {
//         const isProductPage = document.body.classList.contains('template-product');
//         if (!isProductPage) return;
//         // clearInterval(checkInterval);
//         const cart = document.getElementById('floatingCart');
//         const triggerHeight = window.innerHeight + 500;
//         let lastScrollPos = 0;

//         window.addEventListener('scroll', function() {
//             const currentScrollPos = window.scrollY;
//             const scrollThreshold = triggerHeight * 0.8;

//             if (currentScrollPos > triggerHeight && currentScrollPos > lastScrollPos) {
//                 cart.style.bottom = "0";
//             }
//             else if (currentScrollPos < scrollThreshold) {
//                 cart.style.bottom = "-150px";
//             }

//             lastScrollPos = currentScrollPos;
//         });
//     });

/* 底部加购按钮 */









